export const LP_HOME_PAGE_URL = process.env.REACT_APP_LP_HOME_PAGE_URL
// env
export const REACT_APP_BASE_SHEEP_URL = 'https://www.sheepmedical.com'
export const REACT_APP_BASE_WEB_URL = 'https://bioportplus.jp'
export const GTMID = 'GTM-T2NSS8D'
